
import { KnowledgeEntry } from "../types";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ScrollArea } from "@/components/ui/scroll-area";
import { MetadataDetailsView } from "./MetadataDetailsView";
import { FilePreview } from "./FilePreview";

interface EntryDialogContentProps {
  entry: KnowledgeEntry;
}

export function EntryDialogContent({ entry }: EntryDialogContentProps) {
  // Get the AI-generated title or fall back to the original title for display
  const displayTitle = entry.metadata?.generated_title || entry.title || "Untitled Entry";

  return (
    <div className="w-full">
      <Tabs defaultValue="content" className="w-full">
        <TabsList className="mb-4 w-full">
          <TabsTrigger value="content" className="flex-1">Content</TabsTrigger>
          <TabsTrigger value="metadata" className="flex-1">Metadata</TabsTrigger>
        </TabsList>

        <TabsContent value="content" className="space-y-4">
          <ScrollArea className="h-[50vh]">
            {entry.file_url && (
              <div className="mb-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-2 text-sm mb-4">
                  <div>
                    <span className="font-semibold">File Name:</span> {entry.original_filename || 'Unknown'}
                  </div>
                  <div>
                    <span className="font-semibold">File Type:</span> {entry.file_type || 'Unknown'}
                  </div>
                </div>
                <FilePreview entry={entry} />
              </div>
            )}
            
            <div className="whitespace-pre-wrap mt-4">
              {entry.content}
            </div>
          </ScrollArea>
        </TabsContent>
        
        <TabsContent value="metadata">
          <MetadataDetailsView entry={entry} />
        </TabsContent>
      </Tabs>
    </div>
  );
}
